import styled from 'styled-components';
import { colors } from '../../../base/styled/variables.styled';
import { typography } from "../../../base/styled/typography.style";
export const PlaceholderContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors.neutral200};
  border-radius: 4px;
  overflow: hidden;
  border-radius: 100%;

  width: ${({ $width }) => {
    if (typeof $width === 'number')
        return `${$width}px`;
    return $width || '100%';
}};
  height: ${({ $height }) => {
    if (typeof $height === 'number')
        return `${$height}px`;
    return $height || 'auto';
}};

  ${({ $aspectRatio, $height }) => !$height && $aspectRatio &&
    `
    padding-bottom: ${$aspectRatio === '4:3'
        ? '75%'
        : $aspectRatio === '16:9'
            ? '56.25%'
            : $aspectRatio === '3:4'
                ? '133.33%'
                : $aspectRatio === '1:1'
                    ? '100%'
                    : '0'};
    height: 0;
    position: relative;
  `}
`;
export const PlaceholderImageElement = styled.img `
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
export const IconWrapper = styled.div `
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;

	span {
		background-color: ${colors.brand75};
		border-radius: 100%;
		color: ${colors.brand500}!important;
		${typography.linkLarge};
		display: flex;
		width: 100%;
		height: 100%;
		text-align: center;
		justify-content: center;
		align-items: center;
	}
`;
//# sourceMappingURL=Avatar.style.js.map